import { HOME_HAS_ERRORED, HOME_IS_LOADING, HOME_DATA_SUCCESS } from './types';

import { globalFetch } from './globalActions';
import {
  FEED_URLSRC_CMS_V2,
  CMS_PROGROW_TYPE_CATEGORY,
  CMS_PROGROW_TYPE_BOXSET,
  CMS_PROGROW_TYPE_PROGRAMMESET,
} from '../constants';
import { decodeHtml, programmeTitle, isCmsImage, formatUrl } from '../helpers';

///////////
// CMS Home data //
///////////

export function homeFetchDataSuccess(items) {
  //Format the Hero cards
  let heroItems = [];
  if (items.result.heroCards && items.result.heroCards.length > 0) {
    Object.entries(items.result.heroCards).forEach(([key, value]) => {
      heroItems[key] = {
        id: key,
        title: decodeHtml(value.title),
        content: decodeHtml(value.description),
        subheading: decodeHtml(value.preTitle),
        primary_media: value.image && value.image.path ? value.image.path : '',
        primary_media_portrait:
          value.portraitImage && value.portraitImage.path
            ? value.portraitImage.path
            : '',
        entered_url: value.internalPath
          ? value.internalPath
          : formatUrl(value.externalUrl),
        subheading_icon: value.buttonText,
        buttonText: value.buttonText,
      };
    });
    items.result.heroCards = heroItems;
  }

  //Format the programme rows cards
  let progItems = [],
    progTitles = {};
  if (items.result.programmeRows && items.result.programmeRows.length > 0) {
    Object.entries(items.result.programmeRows).forEach(([key, value]) => {
      progItems = [];
      progTitles = {};
      if (value.type === CMS_PROGROW_TYPE_CATEGORY) {
        value.category.programmes &&
          Object.entries(value.category.programmes).forEach(
            ([cardKey, cardValue]) => {
              progTitles = programmeTitle(
                cardValue.seriesTitle,
                cardValue.programmeTitle,
                cardValue.clic_aired
              );
              progItems[cardKey] = {
                id: cardValue.programmeId,
                title: progTitles.title,
                billing: decodeHtml(cardValue.shortBilling),
                subTitle: progTitles.subTitle,
                thumbnail:
                  cardValue.image && cardValue.image.path
                    ? cardValue.image.path
                    : '',
                isCMSThumbnail: isCmsImage(cardValue.image.url),
                isActions: true,
              };
            }
          );
      } else if (value.type === CMS_PROGROW_TYPE_BOXSET) {
        value.boxSet.cards &&
          Object.entries(value.boxSet.cards).forEach(([cardKey, cardValue]) => {
            progItems[cardKey] = {
              id: cardValue.programmeId,
              title: decodeHtml(cardValue.preTitle),
              billing: decodeHtml(cardValue.description),
              subTitle:
                cardValue.title && cardValue.title.length > 0
                  ? decodeHtml(cardValue.title)
                  : cardValue.clic_aired,
              thumbnail:
                cardValue.image && cardValue.image.path
                  ? cardValue.image.path
                  : '',
              isCMSThumbnail: isCmsImage(cardValue.image.url),
              isActions: true,
              count: cardValue.count,
            };
          });
      } else if (value.type === CMS_PROGROW_TYPE_PROGRAMMESET) {
        value.programmeSet.programmeCards &&
          Object.entries(value.programmeSet.programmeCards).forEach(
            ([cardKey, cardValue]) => {
              progItems[cardKey] = {
                id: cardValue.programmeId,
                title: decodeHtml(cardValue.preTitle),
                billing: decodeHtml(cardValue.description),
                subTitle:
                  cardValue.title && cardValue.title.length > 0
                    ? decodeHtml(cardValue.title)
                    : cardValue.programme.clic_aired,
                thumbnail:
                  cardValue.image && cardValue.image.path
                    ? cardValue.image.path
                    : '',
                isCMSThumbnail: isCmsImage(cardValue.image.url),
                isActions: true,
              };
            }
          );
      }
      items.result.programmeRows[key].cards = progItems;
    });
  }

  return {
    type: HOME_DATA_SUCCESS,
    payload: items.result,
  };
}

export function homeFetchData() {
  return globalFetch({
    urlPath: 'sections/homepage',
    urlSrc: FEED_URLSRC_CMS_V2,
    reducerIsLoading: HOME_IS_LOADING,
    reducerError: HOME_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(homeFetchDataSuccess(itemObj));
    },
  });
}
